import type { ReactNode } from 'react';

interface BotaoComBloqueioProps {
  disponivel: boolean;
  motivo?: string;
  caminho?: { label: string; onClick: () => void };
  onClick: () => void;
  children: ReactNode;
}

// SPEC-UX §3.6 — ação indisponível = desabilitada + motivo inline + caminho
// ("Gate indisponível: 2 atividades abertas → ver atividades"). Nunca
// esconder o botão (§8 anti-padrão 6): esconder ensina que a função não
// existe, desabilitar com motivo ensina o fluxo.
export function BotaoComBloqueio({ disponivel, motivo, caminho, onClick, children }: BotaoComBloqueioProps) {
  return (
    <div className="inline-flex flex-col items-start gap-1">
      <button
        type="button"
        disabled={!disponivel}
        onClick={onClick}
        className="rounded bg-aco px-4 py-2 text-sm font-medium text-white hover:bg-aco-700 disabled:cursor-not-allowed disabled:bg-borda disabled:text-grafite"
      >
        {children}
      </button>
      {!disponivel && motivo && (
        <p className="text-xs text-grafite">
          {motivo}
          {caminho && (
            <>
              {' → '}
              <button type="button" onClick={caminho.onClick} className="text-aco underline hover:text-aco-700">
                {caminho.label}
              </button>
            </>
          )}
        </p>
      )}
    </div>
  );
}
